import { heightChanged, legacyHeightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';

export default function createTabs(tabs) {
    return createTabsUnconfigured($, window, document, window.parent, tabs);
}

export function createTabsUnconfigured($, window, document, parentWindow, tabs) {
    function tabIsActive(tab) {
        return (document.querySelector(tab.headingSelector) !== null
            && document.querySelector(tab.headingSelector).classList.contains('active')
            && document.querySelector(tab.contentSelector) !== null
            && !document.querySelector(tab.contentSelector).classList.contains('hide'));
    }

    // Hide all tabs
    function clearTabsSelection() {
        tabs.forEach((element) => {
            $(element.headingSelector).removeClass('active');
            $(element.contentSelector).addClass('hide');
        });
    }

    function showTabContent(tab) {
        const onTabOpen = typeof tab.onTabOpen === 'function' ? tab.onTabOpen : () => {};
        $(tab.headingSelector).addClass('active');
        $(tab.contentSelector).removeClass('hide');
        onTabOpen();
        if (typeof tab.onFirstTabOpen === 'function' && !tab.onFirstTabOpenAlreadyCalled) {
            tab.onFirstTabOpen();
            tab.onFirstTabOpenAlreadyCalled = true;
        }
        parentWindow.postMessage(heightChanged(), '*');
        parentWindow.postMessage(legacyHeightChanged(document), '*');
    }

    // Hide tab content
    function hideTabContent(tab) {
        $(tab.headingSelector).removeClass('active');
        $(tab.contentSelector).addClass('hide');
    }

    // Vraća tab sa hashom iz url-a. Ako hash ne postoji ili nije prepoznat vraća prvi tab.
    function findTabWithHash() {
        let tabWithHash = null;

        tabs.forEach((tab) => {
            const tabHash = $(tab.headingSelector).data('hash');

            if (`#${tabHash}` === window.location.hash) {
                tabWithHash = tab;
            }
        });

        return tabWithHash || tabs[0];
    }

    function setHistoryState() {
        if (!window.history.replaceState) {
            return;
        }

        window.history.replaceState(
            '',
            document.title,
            window.location.pathname + window.location.search + window.location.hash,
        );
    }

    if (!Array.isArray(tabs) || tabs.length <= 0) {
        throw TypeError();
    }

    tabs.forEach((element) => {
        if (element.headingSelector === undefined || element.contentSelector === undefined) {
            throw TypeError();
        }
    });

    tabs.forEach((tab, index) => {
        $(tab.headingSelector).on('click', () => {
            const tabHash = $(tab.headingSelector).data('hash');

            if (tabHash !== undefined) {
                window.location.hash = tabHash;
            }

            clearTabsSelection();
            showTabContent(tab);
        });

        if (!window.location.hash && index === 0) {
            showTabContent(tab);
        } else {
            hideTabContent(tab);
        }
    });

    if (window.location.hash) {
        const tabToOpen = findTabWithHash();
        showTabContent(tabToOpen);
    }

    const openTab = () => {
        const tabToOpen = findTabWithHash();

        // Podrška za back button u browseru
        if (!tabIsActive(tabToOpen)) {
            clearTabsSelection();
            showTabContent(tabToOpen);
            setHistoryState();
        }
    };

    // TODO kako će ovo funkcionirati kada je više različitih tabova na istoj stranici?
    window.addEventListener('hashchange', openTab);

    return () => {
        window.removeEventListener('hashchange', openTab);
    };
}
